<div class="container-data">
    <span class="field-title">{{fielTitle}}</span>
    <span class="field-value">{{value}}</span>
</div>